import Vue from "vue";
import VueRouter from "vue-router";
import login from "../pages/login/index";
import adminLogin from "@/pages/login/adminLogin.vue";
import studyLogin from "@/pages/login/studyLogin.vue";
import pageIndex from "@/pages/index/index.vue";

// 注册vue-router中的所有组件
Vue.use(VueRouter);

const allRouter = [
    {
        path: "/",
        component: login
    },
    {
        path: "/adminLogin",
        component: adminLogin
    },
    {
        path:'/studyLogin',
        component: studyLogin
    },
    {
        path:'/ceshi',
        component:()=>import('@/pages/ceshi/index.vue')
    },
    {
        path:'/index',
        component: pageIndex,
        children:[
            {
                path:'home',
                name:'home',
                component:()=>import('@/pages/home/index.vue')
            },
            {
                path:'userInfo',
                name:'userInfo',
                component:()=>import('@/pages/userInfo/index.vue')
            },
            {
                path:'VocabularyPractice',
                name:'VocabularyPractice',
                component:()=>import('@/pages/VocabularyPractice/layout.vue'),
                children:[
                    // 词汇练习 --- 选择课程
                    {
                        path:'index',
                        name:'index',
                        component:()=>import('@/pages/VocabularyPractice/index.vue')
                    },
                    // 词汇练习 --- 选择单元
                    {
                        path:'unitStudy',
                        name:'unitStudy',
                        component:()=>import('@/pages/VocabularyPractice/unitStudy.vue')
                    },
                    // 词汇练习 --- 过渡页面1
                    {
                        path:'transitionA',
                        name:'transitionA',
                        component:()=>import('@/pages/VocabularyPractice/vocabularyLearning/transitionA.vue')
                    },
                    // 词汇练习 --- 过渡页面2
                    {
                        path:'transitionB',
                        name:'transitionB',
                        component:()=>import('@/pages/VocabularyPractice/vocabularyLearning/transitionB.vue')
                    },
                    // 词汇练习 --- 过渡页面2-2
                    {
                        path:'transitionB-B',
                        name:'transitionB-B',
                        component:()=>import('@/pages/VocabularyPractice/vocabularyLearning/transitionB-B.vue')
                    },
                    // 词汇练习 --- 过渡页面3
                    {
                        path:'transitionC',
                        name:'transitionC',
                        component:()=>import('@/pages/VocabularyPractice/vocabularyLearning/transitionC.vue')
                    },
                    // 词汇练习 --- 第一关
                    {
                        path:'levelOne',
                        name:'levelOne',
                        component:()=>import('@/pages/VocabularyPractice/vocabularyLearning/index.vue')
                    },
                    // 词汇练习 --- 单词学习（PC 新版布局）
                    {
                        path:'wordPractice',
                        name:'wordPractice',
                        component:()=>import('@/pages/wordPractice/index.vue')
                    },
                    // 词汇练习 --- 第二关
                    {
                        path:'levelTwo',
                        name:'levelTwo',
                        component:()=>import('@/pages/VocabularyPractice/vocabularyLearning/LevelTwo.vue')
                    },
                    // 词汇练习 --- 第三关
                    {
                        path:'levelThree',
                        name:'levelThree',
                        component:()=>import('@/pages/VocabularyPractice/vocabularyLearning/LevelThree.vue')
                    },
                    // 词汇练习 --- 单元听写
                    {
                        path:'wordDictation',
                        name:'wordDictation',
                        component:()=>import('@/pages/VocabularyPractice/wordDictation/index.vue')
                    },
                    // 词汇练习 --- 单元默写
                    {
                        path:'WordWriting',
                        name:'WordWriting',
                        component:()=>import('@/pages/VocabularyPractice/WordWriting/index.vue')
                    },
                    // 词汇练习 --- 单元复习
                    {
                        path:'UnitReview',
                        name:'UnitReview',
                        component:()=>import('@/pages/VocabularyPractice/UnitReview/index.vue')
                    }
                ]
            },
            {
                path:'/index/wordList',
                component:()=>import('@/pages/wordList/wrapper.vue'),
                children:[
                    {
                        path:'',
                        name:'wordList',
                        component:()=>import('@/pages/wordList/index.vue')
                    },
                    {
                        path:'selectUnit',
                        name:'selectUnit',
                        component:()=>import('@/pages/wordList/selectUnit.vue')
                    },
                    {
                        path:'wordDetails',
                        name:'wordDetails',
                        component:()=>import('@/pages/wordList/wordDetails.vue')
                    }
                ]
            },
            {
                path:'/index/studyReport',
                name:'studyReport',
                component:()=>import('@/pages/StudyReport/index.vue')
            },

        ]
    }
];
const router = new VueRouter({
    mode: "history",
    routes: allRouter
});
// const originalPush = VueRouter.prototype.push
// // 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
// VueRouter.prototype.push = function push(location) {
//     console.log(originalPush.call(this, location).catch(err => err))
//     return originalPush.call(this, location).catch(err => err)
// }



export default router;

